import React, { Component } from 'react';
import { Form, FormGroup, Label, FormText, FormFeedback } from 'reactstrap';
import Backend from '../../../../Layouts/Backend';
import zxcvbn from 'zxcvbn';
import { withTranslation } from 'react-i18next';
import { Formik } from 'formik';
import { Alert, Input, Button } from '../../../../UI/Common';
import helper from '../../../../../utils/helper';
import PasswordConfirmation from '../../../../UI/PasswordConfirmation';

const ResetPasswordPage = ({ t, loading, error, settings, user, ...props }) => {
  // const [pwdStrength, setPwdStrength] = React.useState(0);
  const validationSchema = helper.pwdValidationSchema({
    containConfirm: true,
    settings,
  });
  const form = {
    password: '',
    confirmPassword: '',
  };
  const getPasswordStrength = (password) => {
    // setPwdStrength(zxcvbn(password).score * 25);
    return zxcvbn(password).score;
  };
  const [openModal, setOpenModal] = React.useState(false);
  const isRequireConfirmation = helper.isRequireConfirmation();
  function onSubmit(values) {
    if (isRequireConfirmation) {
      setOpenModal(true);
    } else {
      props.onResetPassword(values);
    }
  }

  return (
    <Backend title={`Reset Password: ${user ? user.email || '' : ''}`}>
      <div className="content-inner">
        <div className="row">
          <div className="col-4">
            <Formik
              initialValues={form}
              validationSchema={validationSchema}
              onSubmit={(values) => onSubmit(values)}
            >
              {({ values, handleChange, errors, touched, handleSubmit }) => {
                return (
                  <Form>
                    <PasswordConfirmation
                      isOpen={openModal}
                      onCancel={() => setOpenModal(false)}
                      onConfirm={() => {
                        setOpenModal(false);
                        props.onResetPassword(values);
                      }}
                    />
                    {/* <FormGroup>
                      <FormText>
                        {t(
                          'Password must have more than 8 characters, and contain at least one uppercase',
                        )}
                      </FormText>
                    </FormGroup> */}
                    <Input
                      required
                      id="password"
                      type="password"
                      label="Password"
                      onChange={handleChange('password')}
                      value={values.password}
                      invalid={errors.password && touched.password}
                      error={errors.password}
                      accessory={
                        <meter
                          max="4"
                          value={getPasswordStrength(values.password)}
                        />
                      }
                    />
                    <Input
                      required
                      id="confirmPassword"
                      type="password"
                      label="Confirm Password"
                      onChange={handleChange('confirmPassword')}
                      value={values.confirmPassword}
                      invalid={
                        errors.confirmPassword && touched.confirmPassword
                      }
                      error={errors.confirmPassword}
                    />
                    <Alert.Error text={error} />
                    <Button
                      id="reset-password-btn"
                      loading={loading}
                      onClick={handleSubmit}
                    >
                      {t('Reset')}
                    </Button>
                  </Form>
                );
              }}
            </Formik>
          </div>
          <div className="col" />
        </div>
      </div>
    </Backend>
  );
};

export default withTranslation('app')(ResetPasswordPage);
